import { Trans, useTranslation } from 'react-i18next';

import { Body1, Modal } from '@myphx-engineering/phx-design-system';

export type IncentiveTermsModalProps = {
    isOpen: boolean;
    onClose: () => void;
    programName: string;
    termsText: string;
};

export const IncentiveTermsModal = ({
    isOpen,
    onClose,
    programName,
    termsText,
}: IncentiveTermsModalProps) => {
    const { t } = useTranslation('lilly');

    return (
        <Modal
            opened={isOpen}
            onClose={onClose}
            title={t('programs.incentive.termsModalHeader', { programName })}
        >
            <Body1>
                <Trans ns="dynamic" defaults={termsText} />
            </Body1>
        </Modal>
    );
};
